import type { ControlType } from '@risksmart-app/domain/src/types/consts';
import type { ScheduleTRPCInput } from '@risksmart-app/trpc/src/types';
import { mapScheduleToTRPC } from '@risksmart-app/trpc/src/types';
import type {
  InsertChildControlInput,
  InsertChildControlMutation,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import { InsertChildControlDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

type InsertControlInput = Omit<InsertChildControlInput, 'Type'> & {
  Type?: ControlType | null;
};

type InsertControlTRPCInput = Omit<InsertChildControlInput, 'schedule' | 'Type'> &
  ScheduleTRPCInput & {
    Type?: ControlType | null;
  };

export const useInsertControl = createMutationHook({
  name: 'insertControl',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.control.insert.mutationOptions({ onSuccess }),
  mapInput: ({
    schedule,
    ...rest
  }: InsertControlInput): InsertControlTRPCInput => ({
    ...rest,
    ...mapScheduleToTRPC(schedule),
  }),
  invalidate: (trpc) => [
    trpc.frontend.control.register.queryKey(),
    trpc.frontend.control.controlById.queryKey(),
    trpc.frontend.control.controlsByUserId.queryKey(),
    trpc.frontend.control.controlsBasic.queryKey(),
  ],
  mapResponse: (result: { Id: string }): InsertChildControlMutation => ({
    insertChildControl: {
      __typename: 'IdOutput',
      Id: result.Id,
    },
  }),
  graphqlDocument: InsertChildControlDocument,
  graphqlVariables: (input: InsertControlInput) => ({ object: input }),
  evictFields: [
    'risk',
    'control',
    'control_aggregate',
    'obligation',
    'linked_item',
    'risk_score',
  ],
});
